import { render, staticRenderFns } from "./chartBox.vue?vue&type=template&id=475018f5&scoped=true&"
import script from "./chartBox.vue?vue&type=script&lang=js&"
export * from "./chartBox.vue?vue&type=script&lang=js&"
import style0 from "./chartBox.vue?vue&type=style&index=0&id=475018f5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475018f5",
  null
  
)

export default component.exports